import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

export default function ConfirmationCard({
	icon,
	content,
}: {
	icon: React.ReactNode;
	content: string[] | null | undefined | React.ReactNode[];
}) {
	return (
		<Card elevation={0} variant="outlined" sx={{ height: '100%' }} className="appointment-card">
			<CardContent sx={{ height: '100%' }}>
				<Box display="flex">
					{icon}
					<Grid container direction="column" pl={0.5}>
						{content?.map((text: string | React.ReactNode, index: number) => (
							<Typography key={index} variant="bodyLargeBook" color="text.secondary" data-private>
								{text}
							</Typography>
						))}
					</Grid>
				</Box>
			</CardContent>
		</Card>
	);
}
